{
    "glossaries": {
        "list": {
            "language": "Language",
            "new": "New glossary",
            "title": "Title",
            "words": "Words"
        },
        "view": {
            "hint": "Each line represents a separate glossary term. Entries may include full sentences.",
            "language": "Language",
            "save_error": "An error occurred while saving the glossary. Please try again.",
            "save_success": "Glossary saved successfully.",
            "tab_description": {
                "block": "Boosting is applied to proper names, brand names, technical terms, or uncommon words to give them higher priority during transcription, improving accuracy for rare, ambiguous, or context-specific terms. <a href='{0}'>Learn more about boosted words.</a>",
                "boost": "Blocked words are terms or phrases that will not appear in the final transcript. To help maintain professional, compliant transcripts, we apply a default block list for inappropriate or sensitive language. You can add any additional words to be blocked below. <a href='{0}'>Learn more about blocked words.</a>",
                "replace": "Replace applies to specific words or phrases that are automatically substituted with a defined alternative in the transcript. <a href='{0}'>Learn more about replaced words.</a>"
            },
            "tab_hint": {
                "replace": "To replace a term, use the following format: term to replace > replacement term."
            },
            "tab_placeholder": {
                "block": "Enter terms to block, one per line...",
                "boost": "Enter terms to boost, one per line...",
                "replace": "Enter replacement terms, one per line..."
            },
            "title": "Title"
        }
    }
}
